/* scroll top button */
window.addEventListener("scroll", () => {
	let pageTopBtn = document.getElementById('js-scroll-top');
    let currentY = window.pageYOffset;
   if ( currentY > 300){
     setTimeout(function(){
       pageTopBtn.style.opacity = 1;
     }, 1);
     pageTopBtn.classList.remove('is-hide');
   } else {
     setTimeout(function(){
       pageTopBtn.style.opacity = 0;
     }, 1);
     pageTopBtn.classList.add('is-hide');
   }
 });

scrollTop('js-scroll-top', 300); 
 
/* smooth scroll */
function scrollTop(el, duration) {
    let target = document.getElementById(el);
    target.addEventListener('click', function() {
     let currentY = window.pageYOffset; 
     let step = duration/currentY > 1 ? 10 : 100; 
     let timeStep = duration/currentY * step;
     let intervalId = setInterval(scrollUp, timeStep);
 
     function scrollUp(){
       currentY = window.pageYOffset;
       if(currentY === 0) {
           clearInterval(intervalId); 
       } else {
           scrollBy( 0, -step ); 
       }
     }
   });
}     

/* sp menu */
document.querySelector('.js-menu-open').addEventListener('click', function(){
    document.querySelector('.l-nav').classList.toggle('active');
 });
document.querySelector('.js-menu-close01').addEventListener('click', function(){
    document.querySelector('.l-nav').classList.remove('active');
 });
document.querySelector('.js-menu-close02').addEventListener('click', function(){
    document.querySelector('.l-nav').classList.remove('active');
 }); 

var supportsPassive = false;
var scrollables = document.querySelectorAll('.scrollable');
    [].forEach.call(scrollables, function (v) {
        var arrow = v.querySelector('.js-scroll-arrow');
        v.addEventListener('scroll', function () {
            if (Math.floor(v.scrollWidth - v.clientWidth - v.scrollLeft) > 0) {
                arrow.classList.remove('hide');
            } else {
                arrow.classList.add('hide');
            }
            arrow.style.right = -(v.scrollLeft - 20) + 'px';
        }, supportsPassive ? { passive: true } : false);
        var onResize = function () {
            if (v.scrollWidth === v.clientWidth) {
                arrow.classList.add('hide');
            } else {
                arrow.classList.remove('hide');
            }
        };
        onResize();
        window.addEventListener('resize', onResize, supportsPassive ? { passive: true } : false);
});